<ion-content class="">
  <div class="scroll-content-modal">
    <app-header-modal [title]="container?.name || 'Contenedor'" [showToggle]="true" [showClose]="true"
      [bgColor]="'var(--color-gray-100)'" (toggleHeight)="toggleModalHeight()" (close)="closeModal()">
    </app-header-modal>

    @if (container) {
    <div class="modal-content container-modal">
      <div class="card-content">

        <!-- Container Type Badge -->
        <div class="type-badge-section section-margin-2xs">
          <div class="type-badge badge-secondary">
            <img class='icon margin-r-xs icon-20' src="assets/icons/container.svg" alt="Container">
            <span class="type-label p p-medium">{{ 'containerModal.title' | t }}</span>
          </div>
        </div>

        <!-- Address Section + Trust/Source icons -->
        @if (addressString()) {
        <div class="info-row section-margin-2xs clickable" (click)="repointMapOnContainer($event)">
          <div class="row-content address-field">
            <img class='icon icon-secondary margin-r-xs icon-20' src="assets/icons/location.svg" alt="Location">
            <p class="row-text p notranslate" translate="no">{{ addressString() }}</p>
            <app-trust-source-badge [validation]="container.validation" [dataSource]="container.dataSource">
            </app-trust-source-badge>
          </div>
        </div>
        }

        <!-- Description Section -->
        @if (container.description) {
        <div class="description-section section-margin-2xs">
          <app-leer-mas [text]="container.description" [lineClamp]="3" [threshold]="150">
          </app-leer-mas>
        </div>
        }

        <!-- Materials Section -->
        <app-modal-materials-section [materialInput]="inputMaterials()" [materialOutput]="outputMaterials()">
        </app-modal-materials-section>

        <!-- Reference Links + Website -->
        <div class="section-margin-xs">
          <app-links-chips [links]="container.referenceLinks || []" [website]="container.sitio_web" [maxVisible]="4">
          </app-links-chips>
        </div>

        <!-- Action Buttons Slider -->
        <div class="action-slider-section">
          <app-action-buttons-slider [actions]="actionButtons" (actionClick)="onActionButtonClick($event)">
          </app-action-buttons-slider>
        </div>

        <!-- Suggest Edit Button (only when lacking materials or address) -->
        @if (showEditButton()) {
        <div class="button-section section-margin-sm">
          <div class="btn-edit push-btn primary-invert-color-button full-width-button btn-sm" (click)="suggestEdit()">
            <button class="inner-button edit p" [title]="'containerModal.suggestEdit' | t">
              <img src="assets/icons/edit.svg" class="icon-primary icon-20" alt="">
              <span class='btn-text p-semibold line-clamp-1'>{{ 'containerModal.editAddInfo' | t }}</span>
            </button>
          </div>
        </div>
        }

        <!-- Social Section (reports + status + comments) -->
        <div class="">
          <app-social-section [entityId]="container.id" entityType="container">
          </app-social-section>
        </div>

      </div>
    </div>
    }
    <div class="spacing-100"></div>
  </div>
</ion-content>

<!-- Action Sheet for Share Options -->
<ion-action-sheet [isOpen]="isActionSheetOpen" [buttons]="actionSheetButtons" (didDismiss)="isActionSheetOpen = false">
</ion-action-sheet>